import { useReducer } from "react";
import type { SmartViewWidget } from "../../../../../../api/types/dashboardsTypes.ts";
import type { ChartReportConfigurationForRunning } from "../../../../../../api/types/svTypes.ts";
import DrillDownEntry from "../../../../reporting/sv/components/builder/common/drillDown/DrillDownEntry.tsx";
import useViewReportHandlers from "../../../../reporting/sv/components/viewer/common/hooks/useViewReportHandlers.ts";
import { initializeChartRunState, reducer } from "../../../../reporting/sv/components/viewer/storage/runState.ts";
import { isChartRunState } from "../../../../reporting/sv/components/viewer/storage/runStateUtils.ts";
import { BiCommonDataContextProvider } from "../../../../reporting/sv/contexts/BiCommonDataContextProvider.tsx";
import type { DrillDownArgs } from "../DrillDownArgs.ts";
import SmartViewWidgetWrapper from "../SmartViewWidgetWrapper";
import SmartViewChartWidgetViewer from "./SmartViewChartWidgetViewer";
interface Props {
  widget: SmartViewWidget;
  data: ChartReportConfigurationForRunning;
  onDrillDown: (args: DrillDownArgs) => void;
}

const SmartViewChartContainer = ({ data, widget, onDrillDown }: Props) => {
  const [runState, dispatchRunState] = useReducer(reducer, initializeChartRunState(data, widget.reportId));

  const { handleConditionUpdate, handleFieldUpdate, handleRefreshGrid } = useViewReportHandlers(dispatchRunState);

  if (!isChartRunState(runState)) {
    return null;
  }

  return (
    <BiCommonDataContextProvider
      reportType={runState.reportType}
      books={runState.books}
      isMultiBook={runState.isMultiBook}
      dataSetId={runState.dataSetId}
      dimensionsStructure={undefined}
      dimensions={runState.dimensions}
      editMode={false}
      conditions={runState.conditions}
      reportId={widget.reportId}
      refreshToken={runState.refreshToken}
      dimensionNames={runState.dimensionNames}
      measureNames={runState.measureNames}
      onConditionUpdate={handleConditionUpdate}
      onRefreshGrid={handleRefreshGrid}
      onFieldWithCustomConditionUpdate={handleFieldUpdate}
    >
      <SmartViewWidgetWrapper widget={widget} conditions={data.conditions}>
        <SmartViewChartWidgetViewer runState={runState} onDrillDown={onDrillDown} />
        <DrillDownEntry reportId={widget.reportId} />
      </SmartViewWidgetWrapper>
    </BiCommonDataContextProvider>
  );
};

export default SmartViewChartContainer;
